import React, { useState, useEffect } from "react"
import { Paper, Grid, Box } from "@material-ui/core"
import {
  InputTextMaster,
  MasterButton,
  InputOptionMaster,
  InputCheckboxMaster,
  InputReactDatepicker,
  ModalDeleteConfirm,
  InputTextArea,
} from "App/Component/ui"

import {
  RESET_STATE_KUNJUNGAN_RAWAT_JALAN,
  STYLE_MASTER_GUDANG_UTAMA,
  FormAsuransi,
  FormDataPasien,
  validation,
  ModalSEP,
  selectJenisKunjungan,
  ModalUploadFilePenunjang,
  ModalTutupKunjungan,
} from "."
import {
  DEFAULT_BOX_SHADOW,
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance2,
} from "App/constants"

import {
  defaultDateDisplay,
  defaultDateInputDisplay,
  defaultToastError,
  defaultToastSuccess,
  isNull,
  optionCaraMasuk,
  scrollToTop,
  today,
  toUTCFormat,
} from "App/utils/helpers"
import { ImagePreviewIcon, SelectIcon } from "App/Assets"
import {
  createPenjualan,
  sebabSakitSelect,
  useModalBukaKunjungan,
  useModalCancelKunjungan,
  validasiNoBpjs,
  postResepIter
} from "../../utils"
import { LIST_URL_REGISTRASI } from "utils/registrations"
import { useDispatchWrapper } from "hooks"
import { useModalCetakManualSEP } from "./Modal/ModalCetakManualSEP"
import { useSelector } from "react-redux"

import ModalTableListMultiNoRujukanRawatJalan from "./TableListMultiNoRujukan/TableListMultiNoRujukanRawatJalan"
import ModalButtonBookAndKunjBaru from "./Modal/ModalButtonBookAndKunjBaru"
import FormAntrian from "./FormAntrian"
import ModalForceAsuransi from "./Modal/ModalForceAsuransi"
import TableListNoRencanaKontrol from "./TableListRencanaKontrol/TableListNoRencanaKontrol"
import ButtonActionRawatJalan from "./ButtonActionRawatJalan"
import { escapeWhiteSpace, messageError } from "utils/all"
import NomorAntrianJKN from "./NomorAntrianJKN"
import FormJenisLayanan from "./FormJenisLayanan"
import ModalCekResepIterasi from "./Modal/ModalCekResepIterasi"

export default function FormKunjunganRawatJalan({
  handleClickSelectKunjBaru,
  handleClickSelectBooking,
  handleClickWaktuAntrian,
  registrationId,
  setRegistrationId,
  formData,
  setFormData,
  setNewData,
  handleClickReset,
  getAntreanJKN,
}) {
  const classes = STYLE_MASTER_GUDANG_UTAMA()

  const { state } = useDispatchWrapper()
  const ASURANSI_BPJS_ID = state.wrapper_insurance_bpjs_id

  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT)
  const [showModalTutup, setShowModalTutup] = useState(false)

  const { ButtonBukaKunjungan, ModalConfirmBukaKunjungan } =
    useModalBukaKunjungan(registrationId, setNewData)

  const { ButtonCancelKunjungan, ModalCancelKunjungan } =
    useModalCancelKunjungan({
      defaultAlasan: formData.whycancel,
      registrationId,
      setRegistrationId,
      setNewData,
    })

  const { ButtonCetakManualSEP, ModalPrintManualSep } = useModalCetakManualSEP({
    formData,
  })

  const [poliSEP, setPoliSEP] = useState()
  const [showModalSEP, setShowModalSEP] = useState(false)
  const [showModalForce, setShowModalForce] = useState(false)
  const [showModalDuplikasiSEP, setShowModalDuplikasiSEP] = useState({
    state: false,
    message: "",
  })

  const [rowsForce, setRowsForce] = useState([])
  const [showModalUploadFilePenunjang, setShowModalUploadFilePenunjang] =
    useState(false)

  const stateRedux = useSelector((state) => state)
  const master = stateRedux.master
  const setting = stateRedux.setting
  const KELAS_NON_KELAS = setting.id_non_kelas
  const dokterList = master.dokter.list_all
  const dokterSelect = master.dokter.list_select

  const [showModalRencanaKontrol, setShowModalRencanaKontrol] = useState(false)
  const [rowsRencanaKontrol, setRowsRencanaKontrol] = useState([])
  const [rowsRencanaKontrolUtama, setRowsRencanaKontrolUtama] = useState([])
  const [showModalMultiNoRujukan, setShowModalMultiNoRujukan] = useState(false)
  // apotek online
  const [showModalSelectResep, setShowModalSelectResep] = useState(false)

  const handleClickMultiNoRujukan = () => {
    setShowModalMultiNoRujukan(!showModalMultiNoRujukan)
  }

  const checkAsuransiBpjs = () => {
    return parseInt(formData.insurance_id) === parseInt(ASURANSI_BPJS_ID)
  }

  const validJenisKunjungan = () => {
    return parseInt(formData.jenis_kunjungan) === 10
      ? "1"
      : formData.jenis_kunjungan
  }
  const submit = async ({ hakKelas, provUmum, force = false }) => {
    const defaultData = {
      date: toUTCFormat(formData.date),
      jenis_layanan_id: formData.jenis_layanan_id,
      kelaskunjungan_id: formData.kelaskunjungan_id,
      patients_id: formData.patients_id,
      force_cek_insurance: force,
      nohp: formData.nohp,
      nik: formData.nik,
      company_id: formData.company_id,
      insurance_id: formData.insurance_id,
      tanggal_rujukan: isNull(formData?.tanggal_rujukan)
        ? null
        : formData?.tanggal_rujukan,

      insurance_no: formData.insurance_no,
      norujukan: formData.norujukan,
      nokontrol: formData.nokontrol,
      nosep: formData.no_sep,

      umur: formData.umur,
      jenis_kunjungan: validJenisKunjungan(),

      doctor_id: formData.doctor_id,
      sebab_sakit: formData.sebab_sakit,

      poli_layanan: formData.jenis_antrian,

      isexternalrm: parseInt(formData.jenisrm) === 1 ? 1 : 0,

      schedule_doctor_id:
        formData.jenis_antrian === "1" ? formData.schedule_doctor_id : "",
      layanan_id:
        formData.jenis_antrian === "1" ? "" : formData.layanan_ruang_id,

      hak_kelas: checkAsuransiBpjs() ? hakKelas.kode : "",
      nama_hak_kelas: checkAsuransiBpjs() ? hakKelas.keterangan : "",

      kode_ppk_perujuk: checkAsuransiBpjs() ? provUmum.kdProvider : "",
      nama_ppk_perujuk: checkAsuransiBpjs() ? provUmum.nmProvider : "",

      id_antrian_loket: formData.id_antrian_loket,
      tanggal_antrianloket: formData.tanggal_antrianloket,
      tanggal_antrianloket_proses: formData.tanggal_antrianloket_proses,
      remark: formData.remark,

      cara_masuk: formData.cara_masuk,
    }

    if (isNull(registrationId)) {
      return instance2.post(
        LIST_URL_REGISTRASI.kunjungan_rawat_jalan.add_rawat_jalan_onsite,
        {
          ...defaultData,
          pasien_prioritas: formData.pasien_prioritas,
        },
      )
    } else {
      if (formData.is_update_jadwal) {
        return instance2.post(
          LIST_URL_REGISTRASI.kunjungan_rawat_jalan.update_rawat_jalan_antrian,
          {
            ...defaultData,
            pasien_prioritas: formData.pasien_prioritas,
          },
          {
            headers: {
              idregistration: registrationId,
              idbooking: formData.booking_id,
            },
          },
        )
      } else {
        return instance2.post(
          LIST_URL_REGISTRASI.kunjungan_rawat_jalan.update_rawat_jalan_onsite,
          defaultData,
          {
            headers: {
              idregistration: registrationId,
              idbooking: formData.booking_id,
            },
          },
        )
      }
    }
  }

  const addFromBooking = async ({ hakKelas, provUmum, force = false }) => {
    return instance2.post(
      LIST_URL_REGISTRASI.kunjungan_rawat_jalan.add_rawat_jalan_booking,
      {
        date: toUTCFormat(formData.date),
        jenis_layanan_id: formData.jenis_layanan_id,
        kelaskunjungan_id: formData.kelaskunjungan_id,
        patients_id: formData.patients_id,
        force_cek_insurance: force,
        booking_id: formData.booking_id,
        sebab_sakit: isNull(formData.sebab_sakit) ? 0 : formData.sebab_sakit,
        nohp: formData.nohp,
        nik: formData.nik,
        company_id: formData.company_id,
        insurance_id: formData.insurance_id,

        tanggal_rujukan: isNull(formData?.tanggal_rujukan)
          ? null
          : formData?.tanggal_rujukan,
        insurance_no: formData.insurance_no,
        norujukan: formData.norujukan,
        nokontrol: formData.nokontrol,
        umur: formData.umur,
        jenis_kunjungan: validJenisKunjungan(),

        hak_kelas: checkAsuransiBpjs() ? hakKelas.kode : "",
        nama_hak_kelas: checkAsuransiBpjs() ? hakKelas.keterangan : "",

        kode_ppk_perujuk: checkAsuransiBpjs() ? provUmum.kdProvider : "",
        nama_ppk_perujuk: checkAsuransiBpjs() ? provUmum.nmProvider : "",

        id_antrian_loket: formData.id_antrian_loket,
        tanggal_antrianloket: formData.tanggal_antrianloket,
        tanggal_antrianloket_proses: formData.tanggal_antrianloket_proses,
        remark: formData.remark,
      },
    )
  }

  const handleSubmit = async (e, force) => {
    e.preventDefault()
    setDisabled(DISABLED_BUTTON_SUBMIT)
    try {
      if (formData.layanan_id === 3) {
        if (!formData.id_resep_kronis) {
          defaultToastError("Pilih Resep Iterasi Terlebih dahulu!");
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
          return;
        }

        // if (!formData.no_apotik) {
        //   defaultToastError("Tidak dapat melanjutkan registrasi, karena apotek online belum terbuat!");
        //   setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
        //   return;
        // }
      }

      if (isNull(registrationId) && isNull(formData.jenis_kunjungan)) {
        defaultToastError("Jenis kunjungan tidak boleh kosong")
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      } else {
        if (formData.is_from_booking && isNull(registrationId)) {
          const validasiBpjs =
            parseInt(formData.insurance_id) === ASURANSI_BPJS_ID &&
            formData.validasi_bpjs
              ? await validasiNoBpjs(formData.insurance_no)
              : {
                  state: true,
                  message: "",
                  data: {
                    hakKelas: "",
                    provUmum: "",
                  },
                }

          if (validasiBpjs.state) {
            const response = await addFromBooking({
              hakKelas: validasiBpjs.data.hakKelas,
              provUmum: validasiBpjs.data.provUmum,
              force,
            })

            if (response.data.status === 200 || response.data.status === 207) {
              if (formData.layanan_id === 3) {
                await handlePostResepIter(response.data?.registrasi_id);
              }

              await responseBerhasilDenganBooking(response.data, validasiBpjs)
            } else {
              setShowModalForce(true)
              setRowsForce(response.data.body)
            }
          } else {
            defaultToastError(validasiBpjs.message)
          }
        } else {
          const valid = validation(formData, ASURANSI_BPJS_ID)
          if (valid.state) {
            const validasiBpjs =
              parseInt(formData.insurance_id) === ASURANSI_BPJS_ID &&
              formData.validasi_bpjs
                ? await validasiNoBpjs(formData.insurance_no)
                : {
                    state: true,
                    message: "",
                    data: {
                      hakKelas: "",
                      provUmum: "",
                    },
                  }

            if (validasiBpjs.state) {
              const res = await submit({
                hakKelas: validasiBpjs.data.hakKelas,
                provUmum: validasiBpjs.data.provUmum,
                force,
              })

              if (res.data.status === 200 || res.data.status === 207) {
                if (formData.layanan_id === 3) {
                  await handlePostResepIter(res.data?.registrasi_id);
                }

                responseBerhasilTanpaBooking(res.data, validasiBpjs)
              } else {
                /**
                 * status 210
                 * warning no sep sama
                 *
                 * status 204
                 * waning registrasi lebih dari 1x dihari yg sama
                 */

                if (res.data.status === 210) {
                  defaultToastError(res.data.message)
                }

                if (res.data.status === 204) {
                  setShowModalForce(true)
                  setRowsForce(res.data.body)
                }

                if (res.data.status === 206) {
                  setShowModalDuplikasiSEP({
                    state: true,
                    message: res.data.message,
                  })
                }
              }
            } else {
              defaultToastError(validasiBpjs.message)
            }
          } else {
            defaultToastError(valid.message)
          }
        }
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      }
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      defaultToastError(error?.response?.data?.message)
    }
  }

  // const createPenjualanOtomatis = async (registrasi_id) => {
  //   if (parseInt(formData.insurance_id) === ASURANSI_BPJS_ID) {
  //     await createPenjualan({
  //       dokterID: formData.doctor_id,
  //       asuransiNo: formData.insurance_no,
  //       kunjunganID: registrasi_id,
  //       rmID: formData.patients_id,
  //       rmName: formData.nama_rm,
  //       type: "RRJ",
  //       asuransiBpjsId: ASURANSI_BPJS_ID,
  //       kelasID: KELAS_NON_KELAS,
  //       jenisLayananID: formData.jenis_layanan_id,
  //     })

  //     // if (!responsePenjualan.state) {
  //     //   defaultToastError(responsePenjualan.message);
  //     // }
  //   }
  // }

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]:
        text === "no_sep" ? escapeWhiteSpace(e.target.value) : e.target.value,
    })
  }

  const UploadFilePenunjang = () => {
    return (
      <div
        style={{
          marginLeft: "2rem",
          marginTop: "0.7rem",
          cursor: "pointer",
        }}
      >
        <button
          type="button"
          onClick={() =>
            setShowModalUploadFilePenunjang(!showModalUploadFilePenunjang)
          }
          style={{
            border: 0,
            backgroundColor: "transparent",
          }}
        >
          <ImagePreviewIcon width="38" height="38" />
        </button>
      </div>
    )
  }

  const hanleClickButtonSep = () => {
    setPoliSEP({
      value: formData.spesialis_kode,
      label: formData.spesialis_name,
    })
    setShowModalSEP(!showModalSEP)
  }

  useEffect(() => {
    setFormData({
      ...formData,
      date: today(true),
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleChangeSep = (no_sep) => {
    setFormData({
      ...formData,
      no_sep,
    })
  }

  const NomorAntrian = () => {
    if (!isNull(formData.initial) || !isNull(formData.id_antrian_loket)) {
      return (
        <Grid item xs={4}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div
                style={{
                  position: "absolute",
                  marginLeft: "5%",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#fff",
                    boxShadow: DEFAULT_BOX_SHADOW,
                    marginLeft: "0.6rem",
                    marginTop: "2rem",
                    borderRadius: "12px",
                    padding: "2rem 2rem 2rem 2rem",
                    textAlign: "center",
                  }}
                >
                  {!isNull(formData.initial) && (
                    <Antrian
                      antrian={`${formData.initial}-${formData.antrianno}`}
                      title="No Antrian Poli "
                    />
                  )}

                  <br />

                  {!isNull(formData.loket_antriantype_code) && (
                    <>
                      <Antrian
                        antrian={`${formData.loket_antriantype_code}-${formData.loket_antrianno}`}
                        title="No Antrian Loket"
                      />

                      {!isNull(registrationId) && (
                        <MasterButton
                          className="mt-1"
                          type={"button"}
                          color="cyan"
                          name="Waktu Antrian"
                          onClick={() => handleClickWaktuAntrian()}
                          size="lg"
                        />
                      )}
                    </>
                  )}
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
      )
    } else {
      return <></>
    }
  }

  const responseBerhasilTanpaBooking = async (response, validasiBpjs) => {
    if (isNull(registrationId)) {
      defaultToastSuccess("Berhasil menambah kunjungan")
      setFormData({
        ...formData,
        antrianno: response.antrian,
        initial: response.initial,
        id: response.registrasi_id,
        date_cetak_antrian: formData.date,
        insurance_type_name: response.insurance_type_name,
        doctor_schedule_day: response.doctor_schedule_day,
        doctor_schedule_time_start: response.doctor_schedule_time_start,
        doctor_schedule_time_finish: response.doctor_schedule_time_finish,
        doctor_poliklinik_name: response.doctor_poliklinik_name,
        poli_name: response.doctor_poliklinik_name,
        doctor_poliklinik_remark: response.doctor_poliklinik_remark,
        doctor_kodebridge: response.doctor_kodebridge,
        doctor_name: response.doctor_fullname,
        waktu_estimasi_dilayani: response?.waktu_estimasi_dilayani,

        spesialis_kode: response.spesialist_kodebridgepoli,
        spesialis_name: response.spesialist_name,
        nama_hak_kelas: checkAsuransiBpjs()
          ? validasiBpjs.data.hakKelas.keterangan
          : "",
        hak_kelas: checkAsuransiBpjs() ? validasiBpjs.data.hakKelas.kode : "",
      })
      setRegistrationId(response.registrasi_id)
      await getAntreanJKN(response.registrasi_id)
      // await createPenjualanOtomatis(response.registrasi_id)
    } else {
      await getAntreanJKN(response.registrasi_id)
      defaultToastSuccess("Berhasil mengubah kunjungan")
    }

    await setNewData()
  }

  const responseBerhasilDenganBooking = async (response, validasiBpjs) => {
    setFormData({
      ...formData,
      id: response.registrasi_id,
      date_cetak_antrian: formData.date,
      insurance_type_name: response.insurance_type_name,
      doctor_schedule_day: response.doctor_schedule_day,
      doctor_schedule_time_start: response.doctor_schedule_time_start,
      doctor_schedule_time_finish: response.doctor_schedule_time_finish,
      doctor_poliklinik_name: response.doctor_poliklinik_name,
      poli_name: response.doctor_poliklinik_name,
      doctor_poliklinik_remark: response.doctor_poliklinik_remark,
      doctor_kodebridge: response.doctor_kodebridge,
      doctor_name: response.doctor_fullname,
      waktu_estimasi_dilayani: response?.waktu_estimasi_dilayani,
      spesialis_kode: response.spesialist_kodebridgepoli,
      spesialis_name: response.spesialist_name,
      nama_hak_kelas: checkAsuransiBpjs()
        ? validasiBpjs.data.hakKelas.keterangan
        : "",
      hak_kelas: checkAsuransiBpjs() ? validasiBpjs.data.hakKelas.kode : "",
    })
    defaultToastSuccess("Berhasil menambah kunjungan")
    await getAntreanJKN(response.registrasi_id)
    await setNewData()
    // await createPenjualanOtomatis(response.registrasi_id)
    setRegistrationId(response.registrasi_id)
  }

  const updateRegistrasiSEP = (noSep) => {
    const payload = {
      date: toUTCFormat(formData.date),
      jenis_layanan_id: formData.jenis_layanan_id,
      kelaskunjungan_id: formData.kelaskunjungan_id,
      patients_id: formData.patients_id,
      nohp: formData.nohp,
      nik: formData.nik,
      company_id: formData.company_id,
      insurance_id: formData.insurance_id,
      insurance_no: formData.insurance_no,
      norujukan: formData.norujukan,
      nokontrol: formData.nokontrol,
      nosep: noSep,
      umur: formData.umur,
      jenis_kunjungan: validJenisKunjungan(),
      doctor_id: formData.doctor_id,
      sebab_sakit: formData.sebab_sakit,
      tanggal_rujukan: formData?.tanggal_rujukan??"",
    }

    return instance2.post(
      LIST_URL_REGISTRASI.kunjungan_rawat_jalan.update_rawat_jalan_onsite,
      payload,
      {
        headers: {
          idregistration: registrationId,
          idbooking: formData.booking_id,
        },
      },
    )
  }

  const handleShowCekResepIter = () => {
    setShowModalSelectResep(!showModalSelectResep);
  }

  const handlePostResepIter = async (registrationId) => {
    try {
      const payload = {
        "id_kunjungan": registrationId,
        "id_iterasi_resep": formData.id_iterasi_resep,
        "tanggal_registrasi": formData.date,
        "id_resep_kronis": Number(formData.id_resep_kronis),
      }
      const response = await postResepIter(payload);

      if (response.state) {
        defaultToastSuccess(response.data);
      } else {
        defaultToastError(response?.data);
      }
    } catch (error) {
      defaultToastError(error?.response?.data?.message)
    }
  }

  return (
    <>
      {disabled.state && (
        // <FullLoading />
        <div
          style={{
            position: "fixed",
            inset: "0",
            width: "100vw",
            height: "100vh",
            zIndex: 9999999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "black",
            opacity: "70%",
            color: "white",
          }}
        >
          Sedang mengirim data, harap ditunggu...
        </div>
      )}

      {showModalSelectResep && (
        <ModalCekResepIterasi
          setShowModal={() => setShowModalSelectResep(false)}
          noRm={formData.norm}
          formData={formData}
          setFormData={setFormData}
        />
      )}

      {showModalRencanaKontrol && (
        <TableListNoRencanaKontrol
          setShowModal={() => setShowModalRencanaKontrol(false)}
          formData={formData}
          setFormData={setFormData}
          rows={rowsRencanaKontrol}
          setRows={setRowsRencanaKontrol}
          rowsUtama={rowsRencanaKontrolUtama}
          setRowsUtama={setRowsRencanaKontrolUtama}
        />
      )}

      {showModalMultiNoRujukan && (
        <ModalTableListMultiNoRujukanRawatJalan
          setShowModal={() => setShowModalMultiNoRujukan(false)}
          noKartu={formData.insurance_no}
          formData={formData}
          setFormData={setFormData}
        />
      )}

      {showModalTutup && (
        <ModalTutupKunjungan
          registrationId={registrationId}
          setRegistrationId={setRegistrationId}
          setNewData={setNewData}
          setShowModal={() => setShowModalTutup(false)}
        />
      )}

      {showModalForce && (
        <ModalForceAsuransi
          rows={rowsForce}
          handleSubmit={handleSubmit}
          setShowModal={() => setShowModalForce(false)}
        />
      )}

      {showModalDuplikasiSEP.state && (
        <ModalDeleteConfirm
          title="Duplikasi SEP"
          labelConfirm="Ya, saya mengerti"
          msg={showModalDuplikasiSEP.message}
          confirmHandle={() =>
            setShowModalDuplikasiSEP({
              state: false,
              message: "",
            })
          }
        />
      )}

      <ModalConfirmBukaKunjungan />
      <ModalCancelKunjungan />
      <ModalPrintManualSep />

      {showModalSEP && (
        <ModalSEP
          setShowModal={() => setShowModalSEP(false)}
          type="RJ"
          url="/sep_regist/add_rj"
          poliSEP={poliSEP}
          noSep={formData.no_sep}
          pekerjaan={formData.pekerjaan}
          noRujukan={formData.norujukan}
          typeNoRujukan={formData.type_norujukan}
          noKontrol={formData.nokontrol}
          registrationID={registrationId}
          noBPJS={formData.insurance_no}
          tglLahir={defaultDateDisplay(formData.date_ob, false)}
          jenisKelamin={formData.gender_print === 1 ? "L" : "P"}
          patientID={formData.norm}
          tglKunjungan={defaultDateInputDisplay(formData.date, false)}
          handleChangeSep={handleChangeSep}
          dokterKodeBridge={formData.doctor_kodebridge}
          dokterNama={formData.doctor_name}
          updateRegistrasi={updateRegistrasiSEP}
        />
      )}

      {showModalUploadFilePenunjang && (
        <ModalUploadFilePenunjang
          registrationId={registrationId}
          setShowModal={() => setShowModalUploadFilePenunjang(false)}
        />
      )}

      <Paper className={classes.paper}>
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Grid item xs={6}>
              <p style={{ color: "#D8D8D8", fontSize: "10px" }}>ID KUNJUNGAN</p>
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  alignItems: "center",
                }}
              >
                <Box display="flex" flexDirection="row" alignItems="center">
                  <p style={{ fontSize: 30, marginTop: "0.5rem" }}>
                    {" "}
                    {registrationId === "" ? "-" : registrationId}{" "}
                  </p>
                </Box>
                {!isNull(registrationId) && <UploadFilePenunjang />}
              </div>
            </Grid>

            <ModalButtonBookAndKunjBaru
              handleClickSelectBooking={handleClickSelectBooking}
              handleClickSelectKunjBaru={handleClickSelectKunjBaru}
              handleClickReset={handleClickReset}
              formData={formData}
              setFormData={setFormData}
            />
          </Grid>
        </Grid>

        <form onSubmit={(e) => handleSubmit(e)}>
          <div className="mt-1">
            <Grid container spacing={1}>
              <Grid item xs={3}>
                <InputReactDatepicker
                  selected={formData.date}
                  label="TANGGAL"
                  dateFormat="dd/MM/yyyy HH:mm"
                  timeFormat="HH:mm"
                  showTimeSelect
                  timeIntervals={5}
                  isClearable={false}
                  handleChangeToday={(e) =>
                    setFormData({
                      ...formData,
                      date: e,
                    })
                  }
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      date: e,
                    })
                  }
                />
              </Grid>
              <FormJenisLayanan
                handleChange={handleChange}
                formData={formData}
              />
              <Grid item xs={3}>
                <InputTextMaster
                  name="kelaskunjungan_id"
                  label="KELAS KUNJUNGAN"
                  id="kelaskunjungan_id"
                  value="Non Kelas"
                  readOnly
                  disabled={true}
                />
              </Grid>
              <Grid item xs={3}>
                <InputOptionMaster
                  name="sebab_sakit"
                  label="SEBAB SAKIT"
                  id="sebab_sakit"
                  withSearch={false}
                  needParse={false}
                  data={sebabSakitSelect}
                  value={formData.sebab_sakit}
                  onChange={handleChange("sebab_sakit")}
                />
              </Grid>
            </Grid>
          </div>

          <FormDataPasien
            handleChange={handleChange}
            setFormData={setFormData}
            formData={formData}
          />

          <Grid container spacing={2}>
            <Grid item xs={8}>
              <FormAsuransi
                handleChanges={handleChange}
                formData={formData}
                setFormData={setFormData}
              />
            </Grid>
            <NomorAntrian />
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <div
                    style={{
                      display: "flex",
                    }}
                  >
                    <InputTextMaster
                      name="norujukan"
                      label="NO RUJUKAN"
                      id="norujukan"
                      placeholder="No Rujukan"
                      value={formData.norujukan}
                      onChange={handleChange("norujukan")}
                      error={true}
                      message={"Jika BPJS, wajib diisi"}
                    />

                    <MasterButton
                      type={"button"}
                      color="lightgreen"
                      name=""
                      size="sm"
                      withIcon={true}
                      onClick={handleClickMultiNoRujukan}
                      style={{
                        marginTop: "1.5rem",
                        width: "32px",
                        height: "32px",
                      }}
                      icon={
                        <SelectIcon
                          width="16px"
                          height="16px"
                          style={{
                            marginLeft: "-0.5rem",
                          }}
                        />
                      }
                    />
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <InputOptionMaster
                    name="jenis_kunjungan"
                    label="JENIS KUNJUNGAN"
                    id="jenis_kunjungan"
                    withSearch={false}
                    data={selectJenisKunjungan}
                    value={formData.jenis_kunjungan}
                    // disabled={isNull(registrationId) ? false : true}
                    // readOnly={isNull(registrationId) ? false : true}
                    onChange={(e) => {
                      switch (e.target.value) {
                        case "1":
                          setFormData({
                            ...formData,
                            cara_masuk: "gp",
                            cara_masuk_name: "Rujukan FKTP",
                            jenis_kunjungan: e.target.value,
                          })
                          break

                        case "4":
                          setFormData({
                            ...formData,
                            cara_masuk: "hosp-trans",
                            cara_masuk_name: "Rujukan FKRTL",
                            jenis_kunjungan: e.target.value,
                          })
                          break

                        case "2":
                          setFormData({
                            ...formData,
                            cara_masuk: "mp",
                            cara_masuk_name: "Rujukan Spesialis",
                            jenis_kunjungan: e.target.value,
                          })
                          break

                        default:
                          setFormData({
                            ...formData,
                            cara_masuk: "other",
                            cara_masuk_name: "Lain-lain",
                            jenis_kunjungan: e.target.value,
                          })
                      }
                    }}
                    error={true}
                    message={messageError.required}
                  />
                </Grid>
                <Grid item xs={4}>
                  <div
                    style={{
                      display: "flex",
                    }}
                  >
                    <InputTextMaster
                      name="nokontrol"
                      label="NO KONTROL"
                      id="nokontrol"
                      placeholder="No Kontrol"
                      value={formData.nokontrol}
                      onChange={handleChange("nokontrol")}
                    />

                    <MasterButton
                      type={"button"}
                      color="lightgreen"
                      name=""
                      size="sm"
                      withIcon={true}
                      onClick={() =>
                        setShowModalRencanaKontrol(!showModalRencanaKontrol)
                      }
                      style={{
                        marginTop: "1.5rem",
                        width: "32px",
                        height: "32px",
                      }}
                      icon={
                        <SelectIcon
                          width="16px"
                          height="16px"
                          style={{
                            marginLeft: "-0.5rem",
                          }}
                        />
                      }
                    />
                  </div>
                </Grid>

                <Grid item xs={4}>
                  <InputOptionMaster
                    name="cara_masuk"
                    label="CARA MASUK"
                    id="cara_masuk"
                    withSearch={true}
                    data={optionCaraMasuk}
                    value={formData.cara_masuk}
                    labelValue={formData.cara_masuk_name}
                    onChange={(e) => {
                      if (isNull(e)) {
                        setFormData({
                          ...formData,
                          cara_masuk: null,
                          cara_masuk_name: "Pilih Cara Masuk",
                        })
                      } else {
                        setFormData({
                          ...formData,
                          cara_masuk: e.value,
                          cara_masuk_name: e.label,
                        })
                      }
                    }}
                    error={true}
                    message={messageError.required}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                style={{
                  marginTop: "-1.5rem",
                }}
              >
                <Grid item xs={12}>
                  {formData.is_from_booking ? (
                    <FormAntrianBooking formData={formData} />
                  ) : (
                    <FormAntrian
                      poliklinik={master.poliklinik.list_select}
                      setFormData={setFormData}
                      formData={formData}
                      registrasiId={registrationId}
                      dokterSelect={dokterSelect}
                      dokterList={dokterList}
                      handleChange={handleChange}
                      handleShowCekResepIter={handleShowCekResepIter}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              style={{
                marginTop: "-0.5rem",
              }}
            >
              <Grid container spacing={2}>
                {!isNull(registrationId) && (
                  <>
                    <Grid item xs={8}>
                      <FormSEP
                        hanleClickButtonSep={hanleClickButtonSep}
                        noSep={formData.no_sep}
                        handleChange={handleChange}
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>

            {(formData.layanan_id === 3) && (formData.id_resep_kronis) && (
              <Grid item xs={12}>
                <InformationApotekOnline idResep={formData.id_resep_kronis} />
              </Grid>
            )}

            <Grid
              item
              xs={12}
              style={{
                marginTop: "-0.5rem",
              }}
            >
              <Grid container>
                <Grid item sm={3}>
                  <InputCheckboxMaster
                    checked={formData.validasi_bpjs}
                    name="validasi_bpjs"
                    id="validasi_bpjs"
                    label="Validasi BPJS"
                    onChange={() =>
                      setFormData({
                        ...formData,
                        validasi_bpjs: !formData.validasi_bpjs,
                      })
                    }
                  />

                  {!formData.is_from_booking && (
                    <InputCheckboxMaster
                      checked={formData.pasien_prioritas}
                      name="pasien_prioritas"
                      id="pasien_prioritas"
                      label="Prioritas"
                      onChange={() =>
                        setFormData({
                          ...formData,
                          pasien_prioritas: !formData.pasien_prioritas,
                        })
                      }
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              style={{
                marginTop: "-0.5rem",
              }}
            >
              <InputTextArea
                name="remark"
                label="CATATAN"
                placeholder="Catatan"
                id="remark"
                rows={2}
                value={formData.remark}
                onChange={handleChange("remark")}
              />
            </Grid>

            <Grid
              item
              xs={12}
              style={{
                marginTop: "-0.5rem",
              }}
            >
              <NomorAntrianJKN
                getAntreanJKN={getAntreanJKN}
                registrationId={registrationId}
              />
            </Grid>
          </Grid>

          <div className="mt-1">
            <Grid
              container
              direction="row"
              spacing={1}
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid item sm={6}>
                <Grid container direction="row" spacing={1} alignItems="center">
                  {!isNull(registrationId) && (
                    <>
                      {parseInt(setting.buka_tutup_button_rj.tutup) === 1 && (
                        <Grid item>
                          <MasterButton
                            type="button"
                            color={"lightgreen"}
                            name={"TUTUP KUNJUNGAN"}
                            onClick={() => setShowModalTutup(!showModalTutup)}
                            size="md"
                          />
                        </Grid>
                      )}

                      <Grid item>
                        <ButtonCancelKunjungan />
                      </Grid>
                      {parseInt(setting.buka_tutup_button_rj.buka) === 1 &&
                        formData.status && (
                          <Grid item>
                            <ButtonBukaKunjungan />
                          </Grid>
                        )}
                    </>
                  )}
                </Grid>
              </Grid>

              <Grid
                item
                sm={6}
                style={{
                  marginTop: "-1rem",
                }}
              >
                <Grid
                  container
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  justifyContent="flex-end"
                >
                  <Grid item>
                    <MasterButton
                      type="button"
                      color="danger"
                      name="RESET"
                      onClick={() => {
                        // setRegistrationId("");
                        // setFormData({
                        //   ...RESET_STATE_KUNJUNGAN_RAWAT_JALAN,
                        //   jenis_layanan_id: setting.id_jenis_layanan_rj,
                        //   date: today(true),
                        // });
                        // dispatch(changeAntreanJkn(null));
                        // scrollToTop();

                        handleClickReset()
                        scrollToTop()
                      }}
                      size="md"
                    />
                  </Grid>
                  <Grid item>
                    <MasterButton
                      type="submit"
                      color={disabled.color}
                      disabled={disabled.state}
                      name={isNull(registrationId) ? disabled.label : "UPDATE"}
                      size="md"
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              container
              direction="row"
              spacing={1}
              alignItems="center"
              justifyContent="flex-end"
            >
              {!isNull(registrationId) && (
                <>
                  <Grid item>
                    <ButtonCetakManualSEP />
                  </Grid>

                  <ButtonActionRawatJalan
                    formData={formData}
                    registrationId={registrationId}
                  />
                </>
              )}
            </Grid>
          </div>
        </form>
      </Paper>
    </>
  )
}

export const FormSEP = ({ hanleClickButtonSep, noSep = "", handleChange }) => {
  return (
    <Grid container>
      <Grid item xs={10}>
        <InputTextMaster
          name="no_sep"
          label="NO SEP"
          id="no_sep"
          value={noSep}
          onChange={handleChange("no_sep")}
          style={{
            padding: "0.8rem 1rem",
          }}
          placeholder="No SEP"
        />
      </Grid>
      <Grid item xs={2}>
        <MasterButton
          style={{
            marginTop: "1.4rem",
            padding: "0.85rem 3rem",
          }}
          type="button"
          color="warning"
          onClick={() => hanleClickButtonSep()}
          name="SEP"
          size="lg"
        />
      </Grid>
    </Grid>
  )
}

const FormAntrianBooking = ({ formData }) => {
  return (
    <>
      <p className="fw-600 mt-2 fs-12">ANTRIAN</p>

      <div className="mt-1">
        <Grid container>
          <Grid item xs={6}>
            <InputTextMaster
              name="poliname"
              label="POLIKLINIK"
              id="poliname"
              placeholder="Poliklinik"
              value={formData.poliname}
              readOnly={true}
              disabled={true}
            />
          </Grid>
          <Grid item xs={6}>
            <InputTextMaster
              name="nama_dokter"
              label="DOKTER"
              id="nama_dokter"
              placeholder="Dokter"
              value={formData.nama_dokter}
              readOnly={true}
              disabled={true}
            />
          </Grid>
          <Grid item xs={6}>
            <InputTextMaster
              name="schedule"
              label="SCHEDULE DOKTER"
              id="schedule"
              placeholder="Schedule Dokter"
              value={`${formData.day} ${formData.time_start}-${formData.time_finish}`}
              readOnly={true}
              disabled={true}
            />
          </Grid>
        </Grid>
      </div>
    </>
  )
}

const Antrian = ({ title, antrian }) => {
  return (
    <>
      <p>{title}</p>
      <div
        style={{
          display: "flex",
          color: "#296218",
          fontSize: "60px",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: "600",
        }}
      >
        {antrian}
      </div>
    </>
  )
}

const InputCaraMasuk = ({ formData, handleChange, setFormData }) => {
  console.log(formData, "formdata")

  return (
    <>
      <InputOptionMaster
        name="cara_masuk"
        label="CARA MASUK"
        id="cara_masuk"
        withSearch={false}
        data={optionCaraMasuk}
        value={formData.cara_masuk}
        onChange={(e) => {
          setFormData({
            ...formData,
            cara_masuk: e.target.value,
          })
        }}
        error={true}
        message={messageError.required}
      />
    </>
  )
}

const InformationApotekOnline = ({ idResep }) => {
  return (
    <>
      <p
        style={{
          fontSize: "0.75rem",
          background: "#4CAF50",
          color: "#FFF",
          padding: "4px 7px",
          textAlign: "center",
          marginBottom: "10px",
          borderRadius: "10px",
          marginLeft: "10px",
          marginRight: "10px",
        }}
      >
        ID Resep anda <b>{idResep}</b>
        <br/>
        <i>Jika nomor tersebut tidak sesuai, silakan pilih ulang sebelum menyimpan perubahan.</i>
      </p>
    </>
  )
}
